import React from 'react';
import winMoney from '../../../../assets/images/bonus-island/money_1.png';

export /**
 * @param {string} classname - class name for parent element
 * @param {string} winText - wining text
 * @param {number} winAmount - wining amount
 * @param {string} currencyCode - currency code or currency sign
 * MobileTournamentWinning
 */
const MobileTournamentWinning = ({ classname = '', winText, winAmount, currencyCode }) => {
  return (
    <div className={`show-win-block ${classname}`}>
      <div className='inner-show-win-block'>
        <div className='show-win-coin-b'>
          <img src={winMoney} alt='' />
        </div>
        <div className='show-win-b'>{winText} !!!</div>
        <div className='show-next-step-b'>
          <div className='show-next-step-b-item'>
            <span className='win-price'>
              {winAmount} {currencyCode}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
